import PropTypes from 'prop-types'
import Tooltip from 'rc-tooltip'
import Check from 'react-feather/dist/icons/check.js'
import Award from 'react-feather/dist/icons/award.js'

import defaultImage from './default.svg'

import './Picture.scss'

const Picture = (props) => {
  const classes = [ 'picture-component', props.className ]

  if (props.round) {
    classes.push('round')
  }

  if(props.isReviewed || props.isGold) {
    classes.push('component-relative')
  }

  return (
    <div className={classes.join(' ')}>
      {props.isReviewed || props.isGold || props.tooltipLogo ?
        <div className={`labels ${props.isReviewed ? 'label-reviewed' : ''} ${props.tooltipLogo ? 'label-top-right' : ''} ${props.isGold ? 'label-gold' : ''}`}>
          {props.tooltipLogo ?
            <Tooltip placement="bottom" overlay="Accéder au profil Linkedin de l'agent">
              <div className="top-right">
                <img width={13} src={props.tooltipLogo} alt={'Linkedin logo'} />
              </div>
            </Tooltip>
            : ''
          }
          {props.isReviewed ?
            <Tooltip placement="bottom" overlay="Profil qualifié par Twineeds">
              <div className="reviewed">
                <Check size={30} stroke="#FFFFFF" />
              </div>
            </Tooltip>
            : ''
          }
          {props.isGold ?
            <Tooltip placement="bottom" overlay="Profil gold">
              <div className="gold">
                <Award size={30} />
              </div>
            </Tooltip>
            : ''
          }
        </div> : ''
      }
      {props.loading ?
        <div className="image-loading"/> :
        <img
          src={(props.src ? props.src : defaultImage)}
          alt={props.alt}
          style={{'width': props.size ? props.size : '100%'}}
        />
      }
    </div>
  )
}

Picture.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  round: PropTypes.bool,
  loading: PropTypes.bool,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  isReviewed: PropTypes.bool,
  isGold: PropTypes.bool,
  tooltipLogo: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
}

Picture.defaultProps = {
  className: '',
  src: null,
  round: true,
  loading: false,
  size: '100%',
  isReviewed: false,
  isGold: false,
  tooltipLogo: false,
}

export default Picture